import { customAxios, IDUSUARIO, USERNAME, FDV_URL } from '../constants';
import { evalAction, serverError } from './actionError';

export default function(num_ficha_vta_veh,num_pedido_veh,cod_prov,cod_cia,tipoDocumento) {

  console.log('num_pedido_veh',num_pedido_veh);
    const config = {
        headers: {
          idUsuario: IDUSUARIO,
          codUsuario: USERNAME
        },
        params :{
          num_ficha_vta_veh:num_ficha_vta_veh,
          num_pedido_veh:num_pedido_veh,
          cod_prov:cod_prov,
          cod_cia:cod_cia,
          tipoDocumento:tipoDocumento
        }
  };


  const request = customAxios.get(`${FDV_URL}/ficha-venta/fichas-venta/listarHistorialPedido`, config)
                                .then(({ data }) => evalAction(data, 'listarHistorialPedido'))
                                .catch(error => serverError(error, 'listarHistorialPedido'));
  return request;


}



// WEBPACK FOOTER //
// ./src/utils/getHistorialMovPedidos.js